import Vue from 'vue'
import Router from 'vue-router'
import biz from '@/router/router.js'//业务路由
import base from '@/components/base/router/base.js'//基础平台
import wf from '@/components/base/router/wf.js'//流程管理路由
import interact from '@/components/base/router/interact.js'//交流互动模块路由
import ops from '@/components/base/router/ops.js'//运维模块
import news from '@/components/base/router/news.js'//信息中心


import global from '../../../../config/global.js'; // 引入配置文件

var routers = [{
  path: '/',
  redirect: (global && global.homePage) ? global.homePage : '/login'
}];

//引入业务路由
if(biz && biz.length > 0){
    routers = routers.concat(biz);
}
routers = routers.concat(wf).concat(base).concat(interact).concat(ops).concat(news);
Vue.use(Router)
export default new Router({
  // mode: 'history',
  routes: routers,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/base/global/js/router.js